import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogData } from '@fc-shared/ui/confirm-dialog/confirm-dialog.data';

@Component({
  selector: 'fc-confirm-dialog',
  template: `
    <fc-dialog-header
      [title]="$safeNavigationMigration(data?.title)"
    ></fc-dialog-header>
    <fc-dialog-content>
      <p class="confirm-text">{{ data?.message }}</p>
    </fc-dialog-content>
    <fc-dialog-footer
      [primaryText]="$safeNavigationMigration(data?.buttonText)"
      [cancelText]="data?.cancelText || 'Cancel'"
      [warning]="data?.buttonColor === 'warn'"
      [secondaryText]="data?.secondaryText"
      (primaryClicked)="onSubmit()"
      (secondaryClicked)="onSecondary()"
      [cancelFn]="onCancel.bind(this)"
      [haveCancel]="data?.haveCancel ?? true"
    ></fc-dialog-footer>
  `,
  styles: [
    `
      @use 'var' as *;

      .confirm-text {
        color: $grey-600;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: ConfirmDialogData,
  ) {}

  onSubmit(): void {
    this.data.action();
    this.dialogRef.close();
  }

  onCancel(): void {
    if (this.data.cancelAction) {
      this.data.cancelAction();
    }
    this.dialogRef.close();
  }

  onSecondary(): void {
    this.data.secondaryAction?.();
    this.dialogRef.close();
  }
}
